import { apiInstance } from 'api/utils';

const firmApi = {
  getCipProviders: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/firm/cip-providers/'
    });
  },
  getFirmConfig: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/config/firm/'
    });
  },
  setFirmConfig: (data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/config/firm/1/`,
      data: data
    });
  },
  getFirmUsers: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/config/firm/users/'
    });
  },
  updateFirmUsers: (users: any) => {
    return apiInstance.request({
      method: 'POST',
      url: '/config/firm/users/',
      data: { users }
    });
  },
  updateCustomTypicalAssetAllocation: (data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: '/config/firm/custom-typical-asset-allocation/',
      data
    });
  },
  getCustomTypicalAssetAllocation: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/config/firm/custom-typical-asset-allocation/',
      params: { page_size: 50 }
    });
  },
  getDefaultTypicalAssetAllocation: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/config/firm/default-typical-asset-allocation/',
      params: { page_size: 50 }
    });
  },
  reportIssue: (message: string) => {
    return apiInstance.request({
      method: 'POST',
      url: '/report-issue',
      data: { message: message }
    });
  },
  getInvestmentPropositionActivities: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/investment-proposition-activities'
    });
  },
  blankQuestionnaire: (questionnaireType?: string) =>
    apiInstance.request({
      method: 'GET',
      url: '/blank-questionnaire',
      params: { questionnaireType },
      responseType: 'blob'
    }),
  getAdvancedFilterSets: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/advanced-filters/'
    });
  },
  saveAdvancedFilter: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: `/advanced-filters/`,
      data
    }),
  deleteAdvancedFilter: (filterId: any) =>
    apiInstance.request({
      method: 'DELETE',
      url: `/advanced-filters/${filterId}/`
    })
};

export default {
  ...firmApi
};
